export const SELECTED_THEME = 'SELECTED_THEME'
export const IS_CC_SELECTED = 'IS_CC_SELECTED'
export const SELECTED_BRANCH_ID = 'SELECTED_BRANCH_ID'

export const InitialConfig: ConfigType = {
  branchId: 0,
  customerGuid: '',
  interfaceConfig: {
    CLICKCOLLECT: null,
    QRMENU: null
  },
  menuConfig: {
    CLICKCOLLECT: null,
    QRMENU: null
  },
  tableReservationConfig: {
    logoImage: '',
    showRoom: 0
  }
}

export const InitialPaymentConfig: PaymentConfigType = {
  paymentProviderType: 1,
  paymentOnSite: false,
  dataTrans: {
    merchantId: '',
    password: ''
  },
  saferPay: {
    customerId: 0,
    password: '',
    terminalId: 0,
    user: ''
  },
  hsPay: {}
}

export const InitialCCConfig: CCConfigType = {
  leadTimeDays: '0',
  leadTimeHours: '00:00',
  defaultBranchId: 0
}

export type ConfigType = {
  branchId: number
  customerGuid: string
  interfaceConfig: {
    CLICKCOLLECT: InterfaceConfigType | null
    QRMENU: InterfaceConfigType | null
  }
  menuConfig: {
    CLICKCOLLECT: MenuConfigType | null
    QRMENU: MenuConfigType | null
  }
  tableReservationConfig: TableReservationConfigType
  paymentConfig?: PaymentConfigType
  clickCollectConfig?: CCConfigType
  languagesConfig?: Array<AvailableLanguagesType>
  isOldCacheUsed?: boolean
}

export type AvailableLanguagesType =
  | 'de'
  | 'en'
  | 'fr'
  | 'it'
  | 'es'
  | 'pt'
  | 'ja'
  | 'zh'
  | 'zh-HK'
  | 'ar'
  | 'ko'
  | 'th'

export type AdyenStoreType = {
  storeId: string
  storeName: string
}

export type CacheStatusType = {
  id: string
  cacheDate: string
  cacheStatus: 0 | 1
}

export type InterfaceConfigType = {
  font?: string
  colour?: string
  agbText?: string
  dsvgoText?: string
  productViewType?: string
  waiterCall?: boolean
  backgroundImage?: string
  logoImage?: string
  appIcon?: string
  appTheme?: 'light' | 'dark'
}

export type MenuConfigType = {
  bookingVariant: 1 | 2 | 3 | null
  isReservationsShown: 1 | 0 | null
  isSocialsShown: 1 | 0 | null
  notesAvailable: number | null
  paymentVariant: 1 | 2 | null
  selfService: 1 | 0 | null
  tips: number | null
  loginAvailable?: boolean
  isUrlExtended?: boolean
  disabledByMobileWaiter?: boolean
}

export type TableReservationConfigType = {
  logoImage?: string
  showRoom?: number | boolean
  showAllergens?: boolean
  showNote?: boolean
  daysOff?: string
  bookingPossibility?: number
  bookingTimeIntervals?: string
  font?: string
  colour?: string
  bookingLimitPercent?: number
  appTheme?: 'light' | 'dark'
  email?: string
}

// CAPTIONS

export type RoomType = {
  id: number
  caption: string
  restaurantDesignId?: number
}

export type TableType = {
  id: number
  roomId: number
  caption: string
}

export type PaymentConfigType = {
  paymentProviderType: 0 | 1 | 2 | 3
  dataTrans: DatatransType
  saferPay: SaferPayType
  hsPay: HSPayType
  paymentOnSite: boolean
}

export type CCConfigType = {
  leadTimeDays: string
  leadTimeHours: string
  defaultBranchId: number
}

export type HSPayType = {
  shopId?: string
}

export type SaferPayType = {
  customerId: number
  password: string
  terminalId: number
  user: string
}

export type DatatransType = {
  merchantId: string
  password: string
}

export type PaymentHealthType = {
  message: string
  status: 0 | 1
}
